export default {
  getLanguage: (state) => state.language
}
